import Card from "./components/Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import SwiperNavigation from "./SwiperNavigation";
import { productsTypes } from "./products";

// Asegúrate de tener los estilos de Swiper
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

export default function Carrousel() {
  return (
    <div className="container md:px-6 pt-5">
      <div className="relative w-full mx-auto md:max-w-full">
        <h2 className="text-semibold place-self-center text-primary my-4 pb-5">Nuestros productos</h2>

        <Swiper
          modules={[Pagination, Navigation, Autoplay]}
          autoplay={{ delay: 5000 }}
          loop
          watchOverflow
          // En móviles NO centramos; desde lg sí
          centeredSlides={false}
          breakpoints={{
            0:   { slidesPerView: 1, spaceBetween: 12, centeredSlides: false },
            640: { slidesPerView: 2, spaceBetween: 16, centeredSlides: false },
            1024:{ slidesPerView: 3, spaceBetween: 24, centeredSlides: true  },
            1280:{ slidesPerView: 4, spaceBetween: 30, centeredSlides: true  },
          }}
          className="mb-12 overflow-hidden md:!overflow-visible"

        >
          {productsTypes.map((p, i) => (
            <SwiperSlide
              key={i}
              className="flex  md:!overflow-visible relative"
            >
              {/* Evita que el hover rompa el layout en móvil */}
              <div className="transition-transform duration-300 md:hover:scale-105 md:hover:z-10">
                <Card {...p} />
              </div>
            </SwiperSlide>
          ))}

          <SwiperNavigation />
        </Swiper>
      </div>
    </div>
  );
}
